module.exports = __webpack_public_path__ + "img/building-separation.4d45fb9e.svg";